import { parsePhoneNumberFromString } from "libphonenumber-js";

const DEFAULT_COUNTRY = "AU";

export const normalizeCountryCode = (value) => {
  const cleaned = String(value || "").trim();
  return cleaned ? cleaned.toUpperCase() : DEFAULT_COUNTRY;
};

export const inferCountryFromPhoneNumber = (value) => {
  if (!value) return DEFAULT_COUNTRY;
  try {
    const parsed = parsePhoneNumberFromString(String(value));
    return parsed?.country || DEFAULT_COUNTRY;
  } catch (_error) {
    return DEFAULT_COUNTRY;
  }
};

export const isValidPhoneNumberForCountry = (value, countryCode) => {
  const normalizedCountry = normalizeCountryCode(countryCode);
  let rawValue = String(value || "").trim();

  if (!rawValue) return false;

  // Prepend '+' if missing so libphonenumber-js parses the dial code correctly
  if (!rawValue.startsWith("+")) {
    rawValue = "+" + rawValue;
  }

  try {
    const parsed =
      parsePhoneNumberFromString(rawValue, normalizedCountry) ||
      parsePhoneNumberFromString(rawValue);

    if (!parsed) return false;

    if (
      parsed.country &&
      normalizedCountry &&
      parsed.country !== normalizedCountry
    ) {
      return false;
    }

    return parsed.isValid();
  } catch (_error) {
    return false;
  }
};

export { DEFAULT_COUNTRY };
